/*
 * @Description:
 * @Author: HG
 * @Date: 2019-08-21 13:38:08
 * @LastEditors: HG
 * @LastEditTime: 2019-09-29 16:48:47
 */
// import router from "../../router";
import model from "@/api/index";
import { cache } from "@/utils/common";

const user = {
  state: {
    info: {},
  },

  mutations: {
    SET_INFO: (state, info) => {
      state.info = info;
    },
  },

  actions: {
    login({ commit }, to) {
      console.log(commit, to);
      return new Promise((resolve, reject) => {
        const code = to.query.code;
        const url = window.location.href;
        if (!code) {
          model
            .$post("login_GetUrl", {
              ReturnUrl: url,
            })
            .then(res => {
              // const toUrl = unescape(res.Data);
              window.location.href = res.data;
            })
            .catch(err => {
              reject(err);
            });
        } else {
          model
            .$post("login_GetInfo", {
              Code: code,
              ReturnUrl: "",
            })
            .then(res => {
              cache.set("user", res.data, 23 * 60 * 60 * 1000);
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    getUserInfo({ commit }) {
      // const user = cache.get("user");
      commit("SET_INFO", "user");
    },
  },
};

export default user;
